export enum SmokerType {
  Yes = 'SMOKER',
  No = 'NONSMOKER',
  NonSmoker1Year = 'NONSMOKER1YEAR',
}
